import Button from "@Front/Components/DesignSystem/Button";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import classes from "../classes.module.scss";

export type SsoOauthLoginPresetRow = {
	readonly full_name: string;
	readonly email: string;
};

type StepSsoOauthLoginPresetPickerProps = {
	title: string;
	presets: readonly SsoOauthLoginPresetRow[];
	onAccountEmail: (email: string) => void | Promise<void>;
};

export default function StepSsoOauthLoginPresetPicker({
	title,
	presets,
	onAccountEmail,
}: StepSsoOauthLoginPresetPickerProps): React.JSX.Element {
	return (
		<div className={classes["section"]}>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT} className={classes["section-title"]}>
				{title}
			</Typography>
			<ul className={classes["sso-oauth-preset-account-list"]}>
				{presets.map((row) => (
					<li key={row.email}>
						<Button
							type="button"
							fullwidth
							className={classes["sso-oauth-preset-account-button"]}
							aria-label={`Connexion annuaire professionnel en tant que ${row.full_name}, ${row.email}`}
							onClick={() => void onAccountEmail(row.email)}>
							<span className={classes["sso-oauth-preset-account-name"]}>{row.full_name}</span>
							<span className={classes["sso-oauth-preset-account-email"]}>{row.email}</span>
						</Button>
					</li>
				))}
			</ul>
		</div>
	);
}
